export const InfluencersFilterWrapper = (props: React.ComponentProps<'div'>) => (
  <div className="sticky top-(--sticky-influencers-search-height) z-4" {...props} />
);
